import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export const useSignupStatus = () => {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    let live = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/signup/status`)
      .then(({ data }) => { if (live) setEnabled(data.enabled === true); })
      .catch(() => { if (live) setEnabled(false); });
    return () => { live = false; };
  }, []);
  return [enabled, setEnabled];
};

// Under the sign-in card: a new club's way in. A real button, not a footnote.
export const SignupLink = () => {
  const [enabled] = useSignupStatus();
  return enabled === true ? (
    <div className="login-signup" data-testid="login-signup">
      <div>
        <div className="login-signup-title">Шинэ клуб уу?</div>
        <div className="login-signup-sub">Имэйлээр 2 минутад бүртгүүлж, шууд ашиглана</div>
      </div>
      <Link to="/signup" data-testid="login-signup-link" className="login-signup-btn">Үнэгүй бүртгүүлэх</Link>
    </div>
  ) : null;
};

export const SignupBadge = ({ club }) => club.registration_source === 'self_signup' ? (
  <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
    <span data-testid={`club-self-signup-${club.id}`} className="rounded px-2 py-1 bg-emerald-500/15 text-emerald-400">
      Өөрөө бүртгүүлсэн
    </span>
    <time data-testid={`club-registered-at-${club.id}`} dateTime={club.registered_at}
      className="text-[#9CA3AF]">{new Date(club.registered_at).toLocaleDateString('mn-MN')}</time>
  </div>
) : null;

export const signupError = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg).filter(Boolean).join('. ');
  return detail?.message || 'Хүсэлт амжилтгүй. Дахин оролдоно уу.';
};